import TrafficChangesPeriod from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficChangesPeriod";

export const TRAFFIC_PERIOD_VALUES: Record<TrafficChangesPeriod, number> = {
    [TrafficChangesPeriod.MonthOverMonth]: 1,
    [TrafficChangesPeriod.QuoterOverQuoter]: 3,
    [TrafficChangesPeriod.YearOverYear]: 12,
};
